import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import {
  GetProductDetails,
  GetUserLogin,
  GetWishListDetails,
} from "../../../../services";
import { encryptId } from "../../../../../utils/crypto";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import { addToCart } from "../../../../../store/actions/cartActions";
import { Button } from "@material-ui/core";

class Newarrivals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productlist: [],
      isLoaded: false,
      wishlist: [],
      custId: null,
      openQuickView: false,
      selectedProduct: null,
      selectedVariants: [],
      totalMoney: 0,
      visibleCount: 12,
    };
  }

  async componentDidMount() {
    const response = await GetProductDetails.getNewArrivals();

    // if (response) {
    //   const uniqueProducts = response.products.filter(
    //     (product, index, self) =>
    //       index === self.findIndex((p) => p.id === product.id)
    //   );
    //   const limitedProducts = uniqueProducts.slice(0, 12);

    if (response) {
      const excludedIds = [2773];

      const uniqueProducts = response.products
        // remove unwanted product IDs
        .filter((product) => !excludedIds.includes(product.id))
        // keep unique products
        .filter(
          (product, index, self) =>
            index === self.findIndex((p) => p.id === product.id),
        );

      const limitedProducts = uniqueProducts.slice(0, 120);

      this.setState({
        productlist: limitedProducts,
        isLoaded: true,
      });
    } else {
      this.setState({
        isLoaded: true,
      });
    }

    let email = sessionStorage.getItem("email");
    if (email) {
      let user = await GetUserLogin.getCustomerDetail(email);
      if (user) {
        this.setState({ custId: user.data.id });
      }
    }
  }

  toggleWishlist = (productId) => {
    const { wishlist } = this.state;
    const isProductInWishlist = wishlist.includes(productId);

    if (isProductInWishlist) {
      this.setState({ wishlist: wishlist.filter((id) => id !== productId) });
    } else {
      this.setState({ wishlist: [...wishlist, productId] });
    }
  };

  handleAddToWishlistClick = async (productId) => {
    const { custId } = this.state;

    if (!custId) {
      NotificationManager.error("Please log in to add items to your wishlist.");
      return;
    }

    const data = { custId: custId, productId: productId };

    try {
      let result = await GetWishListDetails.addWishlistItem(data);
      if (result) {
        NotificationManager.success("Added to wishlist!");
        this.toggleWishlist(productId);
      } else {
        NotificationManager.error("Product is already in your wishlist.");
      }
    } catch (error) {
      console.error("Error:", error);
      NotificationManager.error(
        "An error occurred while adding to the wishlist.",
      );
    }
  };

  handleQuickView = async (productId) => {
    try {
      const response = await GetProductDetails.getProductById(productId);

      if (response && response.success) {
        this.setState({
          selectedProduct: response.data,
          openQuickView: true,
          selectedVariants: [],
          totalMoney: 0,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  closeQuickView = () => {
    this.setState({
      openQuickView: false,
      selectedProduct: null,
    });
  };

  handleVariantSelect = (variant) => {
    this.setState((prev) => {
      const exists = prev.selectedVariants.find(
        (item) => item.id === variant.id,
      );

      let updated;

      if (exists) {
        updated = prev.selectedVariants.filter(
          (item) => item.id !== variant.id,
        );
      } else {
        updated = [...prev.selectedVariants, variant];
      }

      const totalMoney = updated.reduce(
        (sum, item) => sum + item.variantPrice,
        0,
      );

      return {
        selectedVariants: updated,
        totalMoney,
      };
    });
  };

  handleQuickAddToCart = () => {
    const { selectedProduct, selectedVariants } = this.state;

    if (selectedVariants.length === 0) {
      NotificationManager.error("Please select at least one machine variant.");
      return;
    }

    this.props.addToCart(selectedProduct, selectedVariants);

    NotificationManager.success("Added to cart successfully!");

    this.closeQuickView();
  };

  handleShare = (categoryId) => {
    const shareUrl = `https://jc-creations.co.in/p/${categoryId}`;
    if (navigator.share) {
      navigator
        .share({
          title: "Check out this product!",
          url: shareUrl,
        })
        .then(() => console.log("Share successful"))
        .catch((error) => console.log("Sharing failed", error));
    } else {
      alert("Copy this URL: " + shareUrl);
    }
  };

  handleShowMore = () => {
    this.setState((prevState) => ({
      visibleCount: Math.min(
        prevState.visibleCount + 12,
        prevState.productlist.length
      ),
    }));
  };

  render() {
    const { productlist, isLoaded, wishlist } = this.state;

    return (
      <div>
        <section className="product-items-slider section-padding">
          <div
            className="container"
            id="header-category-bk"
            style={{ padding: "0 15px" }}
          >
            <div className="section-header text-center">
              <h2>New Arrivals</h2>
              <hr />
            </div>
            <div className="row justify-content-center new-arrivals-productlist">
              {!isLoaded ? (
                <div className="progress-bar-bk">
                  <CircularProgress color="secondary" />
                </div>
              ) : (
                productlist
                  .slice(0, this.state.visibleCount)
                  .map((row, index) => (
                    <div
                      key={index}
                      className="col-12 col-md-6 col-lg-4 col-xl-3 mb-4"
                    >
                      <div
                        className="product"
                        style={{ backgroundColor: "black" }}
                      >
                        <Link to={`/p/${encryptId(row.id)}`}>
                          <div
                            className="product-header"
                            style={{
                              position: "relative",
                              // padding: "5px 5px 0px 5px", // small top space
                              overflow: "hidden",
                            }}
                          >
                            <img
                              crossOrigin="anonymous"
                              className="img-fluid lazyload"
                              src={row.photo}
                              alt={row.name}
                              style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "contain",
                                display: "block",
                                borderRadius: "6px",
                              }}
                            />

                            <div className="product-actions">
                              {/* Wishlist */}
                              <i
                                className={`mdi ${wishlist.includes(row.id)
                                  ? "mdi-heart"
                                  : "mdi-heart-outline"
                                  }`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.handleAddToWishlistClick(row.id);
                                }}
                              />

                              <i
                                className="mdi mdi-eye-outline"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.handleQuickView(row.id);
                                }}
                              />
                            </div>
                          </div>
                          <div className="product-body">
                            <h6 style={{ display: "none" }}>
                              <strong>
                                <span className="mdi mdi-approval" /> Code
                              </strong>{" "}
                              - {row.slug}
                            </h6>
                          </div>
                        </Link>
                        <div className="product-footer">
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm float-right"
                            onClick={() => this.handleShare(row.id)}
                          >
                            <i className="mdi mdi-share" /> Share
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
              )}
            </div>
            {this.state.visibleCount < productlist.length && (
              <div
                style={{
                  textAlign: "center",
                  marginTop: "30px",
                  marginBottom: "20px",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleShowMore}
                  style={{
                    padding: "10px 35px",
                    borderRadius: "30px",
                    textTransform: "none",
                    fontWeight: 600,
                    backgroundColor: "#e96125"
                  }}
                >
                  Show More
                </Button>
              </div>
            )}
          </div>
        </section>

        {this.state.openQuickView && this.state.selectedProduct && (
          <div className="quick-view-overlay">
            <div className="quick-view-modal">
              <button className="close-btn" onClick={this.closeQuickView}>
                ×
              </button>

              <div className="row">
                {/* IMAGE */}

                <div className="col-12 col-lg-4">
                  <img
                    src={this.state.selectedProduct.photo}
                    alt=""
                    className="quick-product-image"
                  />
                </div>

                {/* DETAILS */}

                <div className="col-12 col-lg-4">
                  <h2 className="quick-product-title">
                    {this.state.selectedProduct.name}
                  </h2>

                  <div className="quick-detail-card">
                    <h5>🧵 Stitch Details</h5>

                    <p>{this.state.selectedProduct.stitches}</p>
                  </div>

                  <div className="quick-detail-card">
                    <h5>📏 Dimensions</h5>

                    <p>{this.state.selectedProduct.height}</p>
                  </div>

                  <div className="quick-detail-card">
                    <h5>📝 Description</h5>

                    <p>{this.state.selectedProduct.sortDesc}</p>
                  </div>
                </div>

                {/* VARIANTS */}

                <div className="col-12 col-lg-4">
                  <div className="variant-header">
                    <h4>Select Machine</h4>

                    <h3>₹{this.state.totalMoney}</h3>
                  </div>

                  {this.state.selectedProduct.productvariants
                    ?.slice()
                    .sort((a, b) => a.variantName.localeCompare(b.variantName))
                    .map((variant) => {
                      const selected = this.state.selectedVariants.some(
                        (item) => item.id === variant.id,
                      );

                      return (
                        <div
                          key={variant.id}
                          className={`variant-card ${selected ? "active" : ""}`}
                          onClick={() => this.handleVariantSelect(variant)}
                        >
                          <div>
                            <strong>{variant.variantName}</strong>
                          </div>

                          <div>₹{variant.variantPrice}</div>
                        </div>
                      );
                    })}
                </div>
              </div>

              <div className="quick-footer">
                <button
                  className="wishlist-btn-modern"
                  onClick={() =>
                    this.handleAddToWishlistClick(this.state.selectedProduct.id)
                  }
                >
                  <i className="mdi mdi-heart-outline" />
                  Wishlist
                </button>

                <button
                  className="cart-btn-modern"
                  onClick={this.handleQuickAddToCart}
                >
                  <i className="mdi mdi-cart" />
                  Add To Cart
                  {this.state.totalMoney > 0 && ` • ₹${this.state.totalMoney}`}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(null, { addToCart })(withRouter(Newarrivals));
